
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"cx":"5.36","cy":"12.47","rx":"3.36","ry":"3.35","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('ellipse',{attrs:{"cx":"32.89","cy":"12.47","rx":"3.36","ry":"3.35","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('ellipse',{attrs:{"cx":"13.52","cy":"4.85","rx":"3.36","ry":"3.35","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('ellipse',{attrs:{"cx":"24.73","cy":"4.85","rx":"3.36","ry":"3.35","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M27.29 18.34c-2.5-3.54-5.78-6.46-8.16-6.46-4.36 0-11.76 9.78-11.76 15.33a3.36 3.36 0 003.36 3.36c2.52 0 5-2.52 8.4-2.52","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('ellipse',{attrs:{"cx":"28.07","cy":"28.58","rx":"9.93","ry":"9.92","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M24.59 32.05l6.95-6.94M31.54 32.05l-6.95-6.94"}})])
          )
        }
      }
    